import { useRequest } from 'ahooks'

import { toast } from '$app/utilities'

import { AnonymousAuthAPI } from '$api/anonymous-auth'

import { MobileOTPRequestFormProps } from '$hook-forms/MobileOTPRequestForm'

import useRouter from './useRouter'
import { MobileOTPRequestRequest } from '$api/types'

const { mobileOTPRequest, errorMessageResolver, successResolver } =
  new AnonymousAuthAPI(null)

type OnSuccess = MobileOTPRequestFormProps['onSuccess']

export const useMobileOTPRequest = (): MobileOTPRequestFormProps => {
  const { redirect } = useRouter()

  const { loading, runAsync, error } = useRequest(mobileOTPRequest, {
    manual: true
  })

  const errorMessage = (() => {
    if (!error) return

    return errorMessageResolver(error, 'Invalid credential')
  })()

  const onSuccess: OnSuccess = async (reset, { is_whatsapp, ...data }) => {
    const payload: MobileOTPRequestRequest = {
      ...data,
      send_via: is_whatsapp ? 'whatsapp' : 'sms'
    }

    const {
      data: { reference_number }
    } = await toast
      .promise(runAsync(payload), {
        loading: 'Requesting..',
        success: 'OTP requested'
      })
      .unwrap()
      .then(successResolver)

    reset()

    redirect('authSmsOtpVerify', ({ queryParams }) => ({
      queryParams: {
        // Carry current parameters
        ...queryParams,

        // Pass OTP ref number for retry
        reference_number
      }
    }))
  }

  return { onSuccess, disabled: loading, errorMessage }
}

export default useMobileOTPRequest
